export default "__VITE_ASSET__BVYjv_v9__"